module.exports = __webpack_public_path__ + "img/c08_unittechturangachampion_Normal_ua.5c133621.webp";